import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

import { AttendancePageScreens } from './types';

interface AttendancePageContextType {
  /** @default RECORD_ATTENDANCE */
  currentScreen: AttendancePageScreens;
  setCurrentScreen: React.Dispatch<React.SetStateAction<AttendancePageScreens>>;
}

const AttendancePageContext = createContext<AttendancePageContextType | undefined>(undefined);

export function useAttendancePageContext() {
  const context = useContext(AttendancePageContext);
  if (!context) {
    throw new Error('Using useAttendancePageContext outside AttendancePageContextProvider is not allowed.');
  }
  return context;
}

function useAttendancePageContextProviderVM() {
  const [currentScreen, setCurrentScreen] = useState<AttendancePageScreens>(
    AttendancePageScreens.RECORD_ATTENDANCE
  );

  return useMemo(
    () => ({
      currentScreen,
      setCurrentScreen,
    }),
    [currentScreen]
  );
}

export interface AttendancePageContextProviderProps {
  children: ReactNode;
}

export function AttendancePageContextProvider({ children }: AttendancePageContextProviderProps) {
  const providerValue = useAttendancePageContextProviderVM();

  return <AttendancePageContext.Provider value={providerValue}>{children}</AttendancePageContext.Provider>;
}
